import { render, staticRenderFns } from "./ConfigLinkIcon.vue?vue&type=template&id=a31c2236"
import script from "./ConfigLinkIcon.vue?vue&type=script&lang=js"
export * from "./ConfigLinkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports